import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';
import './highlighteditem.scss';

function formatPrice(priceValue) {
    if (priceValue === null || priceValue === undefined || priceValue === '') {
        return null;
    }
    const numeric = parseFloat(String(priceValue).replace(/[^\d.-]/g, ''));
    if (Number.isNaN(numeric)) {
        return null;
    }
    return `AU $ ${numeric.toFixed(2)}`;
}

export function HighlightedItem(props) {
    const item = props.item;
    const cmsOption = props.cmsOption || {};

    const bgUrl = utils.site.resourcePath(cmsUtils.payload(item, 'ImageUrl'));
    const title = cmsUtils.payload(item, 'CardTitle');
    const description = cmsUtils.payload(item, 'CardDescription');
    const linkUrl = cmsUtils.payload(item, 'LinkUrl');
    const bullet1 = cmsUtils.payload(item, 'Bullet1');
    const bullet2 = cmsUtils.payload(item, 'Bullet2');
    const bullet3 = cmsUtils.payload(item, 'Bullet3');
    const bullet4 = cmsUtils.payload(item, 'Bullet4');
    const buttonText = cmsUtils.payload(item, 'ButtonText') || 'Subscribe Now';
    const imageTitle = cmsUtils.payload(item, 'ImageTitle');
    const imageDes = cmsUtils.payload(item, 'ImageDes');
    const priceRaw = cmsUtils.payload(item, 'Price');
    const formattedPrice = formatPrice(priceRaw);

    const rawBullets = [
        { text: bullet1, variant: 'check' },
        { text: bullet2, variant: 'check' },
        { text: bullet3, variant: 'check' },
        { text: bullet4, variant: 'cross' },
    ];
    const bullets = rawBullets.filter((b) => b.text && b.text !== '');

    const cssClass = utils.classNames('cms_item', 'highlightedItem', item.cssClass || item.anchorName || '');

    return (
        <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
            <div className="highlightedItem__media">
                {bgUrl && (
                    <div className="highlightedItem__image" style={{ backgroundImage: utils.css.bgUrlStyle(bgUrl) }} />
                )}
                <div className="highlightedItem__overlay" aria-hidden="true" />
                {(imageTitle || imageDes) && (
                    <div className="highlightedItem__imageText">
                        {imageTitle && (
                            <div className="highlightedItem__imageTitle" dangerouslySetInnerHTML={{ __html: imageTitle }} />
                        )}
                        {imageDes && (
                            <div className="highlightedItem__imageDes" dangerouslySetInnerHTML={{ __html: imageDes }} />
                        )}
                    </div>
                )}
            </div>
            <div className="highlightedItem__body">
                {title && (
                    <h3 className="highlightedItem__title" dangerouslySetInnerHTML={{ __html: title }} />
                )}
                {description && <div className="highlightedItem__desc" dangerouslySetInnerHTML={{ __html: description }} />}
                {formattedPrice && <div className="highlightedItem__price">{formattedPrice}</div>}
                {linkUrl && (
                    <SiteLink to={linkUrl} className="highlightedItem__btn">
                        {buttonText}
                    </SiteLink>
                )}
                {bullets.length > 0 && (
                    <ul className="highlightedItem__bullets">
                        {bullets.map((b, i) => (
                            <li
                                key={i}
                                className={utils.classNames(
                                    'highlightedItem__bullet',
                                    b.variant === 'cross' ? 'highlightedItem__bullet--cross' : 'highlightedItem__bullet--check'
                                )}
                            >
                                <span dangerouslySetInnerHTML={{ __html: b.text }} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
